import { Box } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Assuming you're using React Router
import useAPI from "../../../../api/hooks/useAPI";
import { integrationKeys } from "../../../../api/queryKeys";
import LoadingIcon from "../../../../components/LoadingIcon";
import { Toast } from "../../../../components/Toast";

/*this component is used to handle the redirect from GitHub after the user has installed the app on their GitHub account for the first time,
For register the integration with the Breeze platform and store the installation ID and customer id for identifying the customer's GitHub account*/
const HandleGitHubRedirect = () => {
  const [installationId, setInstallationId] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { registerGitHubIntegration } = useAPI();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    // Parse the query string from the URL
    const query = new URLSearchParams(location.search);
    const installationId = query.get("installation_id");

    if (installationId) {
      setInstallationId(installationId);
      // Optionally, do something with the installation ID, like storing it or initializing setup
    }
  }, [location]);
  useEffect(() => {
    if (installationId) setLoading(true);
    registerGitHubIntegration(installationId)
      .then((response) => {
        queryClient.invalidateQueries({
          queryKey: integrationKeys.all,
        });
        Toast.success("GitHub integration successful");
        setLoading(false);
        navigate("/inventory/integrations");
      })
      .catch((error) => {
        console.error(error);
      });
  }, [installationId]);

  if (!installationId) {
    return <p>Invalid installation or no installation ID found.</p>;
  }

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {loading ? <LoadingIcon /> : <p>GitHub App installed successfully!</p>}
    </Box>
  );
};

export default HandleGitHubRedirect;
